import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'
import { emailAndPhoneSelector } from 'selectors'
import Page from 'rui/widgets/Page'
import DriveSidebar from 'components/layout/DriveSidebar'
import Thin from 'components/layout/Thin'
import Panel, { PanelHeading, PanelSubheading } from 'components/layout/Panel'
import Form from 'components/form'
import Input from 'components/form/Input'
import { required } from 'components/form/validations'
import { updateProfile } from 'actions/profile'
import get from 'lodash/get'
import { Body1 } from 'components/layout/text'
import Spacer from 'components/misc/Spacer'
import { ExternalLink } from 'components/layout/links'
import { FeatureFlag } from 'Optimizely'
import { LocalizedRichText, LocalizedText, withLocalization } from 'localization'

const EmailAndPhonePage = ({ profile, dispatch, isLocked, flags, localization }) => {
  const { t } = localization

  const handleData = (editingEnabled) => (data) => {
    if (!editingEnabled) {
      return Promise.resolve()
    }

    if (data.phone_number === profile.phone_number && data.email === profile.email) {
      return Promise.reject({
        response: {
          data: { errors: { base: `You haven't made any changes.` } },
        },
      })
    } else {
      const phoneChanged = data.phone_number !== profile.phone_number
      return dispatch(updateProfile({ profile: data })).then(
        () => {
          if (phoneChanged) {
            dispatch({
              type: 'PUSH_FLASH',
              flash: {
                type: 'alert',
                messageKey: 'dweb_phone_verification_text_message_sent_to_period',
                messageParams: { phoneNumber: data.phone_number },
              },
            })
          } else {
            dispatch({
              type: 'PUSH_FLASH',
              flash: {
                type: 'success',
                messageKey: 'dweb_flash_profile_changes_saved',
              },
            })
          }
        },
        (res) => {
          const message = get(res, 'response.data.errors.user')
          dispatch({
            type: 'PUSH_FLASH',
            flash: message
              ? { type: 'error', message }
              : { type: 'error', messageKey: 'dweb_flash_contact_info_update_failed' },
          })
        }
      )
    }
  }

  const isDriver = flags['basic_user_propensity'] === 'driver'

  return (
    <Page sidebar={<DriveSidebar />}>
      <Helmet>
        <title>{t('dweb_layout_drive_sidebar_email_phone')}</title>
      </Helmet>
      <Thin>
        <FeatureFlag feature="drive_phone_email_update_enabled">
          {(enabled) => (
            <Form id="email-and-phone-form" onData={handleData(enabled)}>
              <Panel>
                <PanelHeading>
                  <LocalizedText translationKey="dweb_layout_drive_sidebar_email_phone" />
                </PanelHeading>
                <PanelSubheading>
                  <LocalizedText translationKey="dweb_account_email_and_phone_verify_edit_email_address_phone_number" />
                </PanelSubheading>

                <Input.Email
                  disabled={!enabled || isLocked || !isDriver}
                  className="fs-block"
                  label={t('dweb_forgot_password_email_address')}
                  name="email"
                  validate={required}
                  defaultValue={profile.email}
                />

                <Input.Phone
                  disabled={!enabled || isLocked || !isDriver}
                  className="fs-block"
                  label={t('dweb_account_email_and_phone_mobile_number')}
                  name="phone_number"
                  validate={required}
                  defaultValue={profile.phone_number}
                />

                {enabled ? (
                  <Input.Submit value={t('dweb_common_save')} disabled={isLocked} />
                ) : (
                  <>
                    <Spacer />
                    <Body1>
                      <LocalizedRichText
                        translationKey="dweb_account_basic_info_registration_update_information_please_contact_link1"
                        params={{
                          link1: (
                            <ExternalLink href={`${import.meta.env.REACT_APP_SUPPORT_URL}/support/s/contactsupport`}>
                              <LocalizedText translationKey="dweb_account_basic_info_registration_roadie_support" />
                            </ExternalLink>
                          ),
                        }}
                      />
                    </Body1>
                  </>
                )}
              </Panel>
            </Form>
          )}
        </FeatureFlag>
      </Thin>
    </Page>
  )
}

export default connect(emailAndPhoneSelector)(withLocalization(EmailAndPhonePage))
